import { ShieldCheck, Star, Headphones, BadgePoundSterling } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "Secure Stripe payments" },
  { icon: Star, label: "Trusted by 12,000+ UK travellers" },
  { icon: Headphones, label: "24/7 UK-based support" },
  { icon: BadgePoundSterling, label: "Best-price promise" },
];

export const TrustRibbon = () => (
  <section data-testid="trust-ribbon" className="max-w-7xl mx-auto px-4 sm:px-6 mt-8">
    <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-3 rounded-2xl border border-white/10 bg-white/[0.03] px-6 py-4">
      {ITEMS.map(({ icon: Icon, label }) => (
        <span key={label} className="flex items-center gap-2 text-sm text-slate-300">
          <Icon className="w-4 h-4 text-[#FF6B35]" />
          <span className="font-medium">{label}</span>
        </span>
      ))}
    </div>
  </section>
);
